// extracted by mini-css-extract-plugin
module.exports = {"list":"list--ff11fa","list_horizontal":"list_horizontal--607a06","list_align_right":"list_align_right--0dc05b","list__item":"list__item--38f92b"};